"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMerkleHash = void 0;
const zod_1 = require("zod");
const constants_1 = require("../../utils/constants");
const MerkleHashSchema = zod_1.z.object({
    merkle_hash_version: zod_1.z.number().int().positive(),
});
const validateMerkleHash = (data) => {
    const result = MerkleHashSchema.safeParse(data);
    if (!result.success) {
        return { merkle_hash_version: constants_1.MERKLE_HASH_VERSIONS.ONE };
    }
    return result.data;
};
exports.validateMerkleHash = validateMerkleHash;
//# sourceMappingURL=merkleHash.js.map